import React from 'react'
import { Element } from 'react-bulma-components'
import Avatar from '../avatar/avatar'
import { AvailableWorker } from '../../api/users'
import { WorkersRequestPostDesiredWorkersProps } from './desired-workers'

interface WorkersRequestDesiredWorkerProps extends WorkersRequestPostDesiredWorkersProps {
  worker: AvailableWorker
  onClick?(worker: AvailableWorker): void
  isAvailable?: boolean
}

const WorkersRequestPostDesiredWorker: React.FC<WorkersRequestDesiredWorkerProps> = ({
  workersRequest,
  worker,
  availableWorkers,
  onClick,
  isAvailable,
}) => {
  const isAlreadyAssigned = React.useMemo(() => {
    return workersRequest.posts.find(
      post =>
        !post.isReplaceable && post.missions[post.missions.length - 1]?.user._id === worker._id,
    )
  }, [workersRequest, worker])

  const tooltipText = React.useMemo<string | undefined>(() => {
    if (isAlreadyAssigned) return 'Déjà assigné à la demande'
    else if (isAvailable) return 'Disponible'
    else if (availableWorkers) return 'Non disponible'
    return
  }, [isAlreadyAssigned, isAvailable])

  return (
    <Element
      renderAs={isAvailable && onClick ? 'a' : 'span'}
      onClick={() => isAvailable && onClick?.(worker)}
      data-tooltip={tooltipText}
    >
      <Avatar user={worker} />
    </Element>
  )
}

export default WorkersRequestPostDesiredWorker
